import { AppTooltip } from '@/lib/components';
import { Button, ButtonProps } from 'antd';
import { FC } from 'react';
import styles from './styles.module.scss';

export type CustomButtonColor =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'danger'
  | 'link';
export type CustomButtonType = ButtonProps['type'] | 'ghost';

export type CustomButtonProps = Omit<ButtonProps, 'color' | 'type'> & {
  color?: CustomButtonColor;
  type?: CustomButtonType;
  toolTipKey?: string;
  iconOnly?: boolean;
  disableToolTip?: boolean;
};

export const CustomButton: FC<CustomButtonProps> = ({
  color = 'primary',
  iconOnly = false,
  children,
  shape,
  toolTipKey,
  disableToolTip,
  ghost,
  type,
  danger,
  className,
  ...rest
}) => {
  const classes: string[] = [styles.button, styles[color]];
  if (ghost || type === 'ghost') {
    classes.push(styles.ghost);
  }

  if (danger) {
    classes.push(styles.danger);
  }

  if (type === 'link') {
    classes.push(styles.link);
  }
  if (className) {
    classes.push(className);
  }

  const buttonType: ButtonProps['type'] = type === 'ghost' ? 'default' : type;

  const childComp = (
    <Button
      shape={shape ?? (iconOnly ? 'circle' : 'round')}
      className={classes.join(' ')}
      type={buttonType}
      ghost={ghost || type === 'ghost'}
      danger={danger}
      {...rest}
    >
      {!iconOnly && children}
    </Button>
  );

  return disableToolTip ? (
    childComp
  ) : (
    <AppTooltip toolTipKey={toolTipKey}>{childComp}</AppTooltip>
  );
};
